import { GetPageData as GetPageDataRequest } from "../page/api/entityService";

// Carries whether the read failed because there is no such record, so the page can
// say so rather than blaming itself.
export class PageDataError extends Error {
  constructor(message, notFound) {
    super(message);
    this.name = "PageDataError";
    this.notFound = notFound === true;
  }
}

// Throws on failure instead of silently returning a response with no `.data`.
export async function getPageData(dispatch, entityName, id, formId) {
  const response = await GetPageDataRequest(
    dispatch,
    entityName,
    id,
    formId
  );

  if (!response || !response.data) {
    // `Get` resolves with the axios error rather than rejecting, so the status
    // sits on the error's own response.
    throw new PageDataError(
      `Failed to load page data for ${entityName}`,
      response?.response?.status === 404
    );
  }

  return response.data;
}
